import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChambreS from './assets/chambreSingle.jpg';
import ChambreD from './assets/chambreD15.jpg';
import ChambreT from './assets/triple1.jpg';
import './aobergePage.css';

const AobergePage = () => {
  const navigate = useNavigate();

  const chambres = [
    {
      id: 1,
      type: "Chambre Single",
      description: "Chambres de 20 à 25 m², dotées d’une literie haut de gamme, d’un téléviseur plasma avec chaînes câblées, du Wi-Fi gratuit, d’un réfrigérateur, d’un coffre-fort, d’une salle de bain privative, ainsi que d’une climatisation et d’un chauffage centralisés. Lits supplémentaires disponibles sur demande.",
      image: ChambreS,
      prix: "12000.00 DA/nuit",
      "option vue sur mer": "+ 2500.00 DA"
    },
    {
      id: 2,
      type: "Chambre Double",
      description: "Chambres de 20 à 25 m², dotées d’une literie haut de gamme, d’un téléviseur plasma avec chaînes câblées, du Wi-Fi gratuit, d’un réfrigérateur, d’un coffre-fort, d’une salle de bain privative, ainsi que d’une climatisation et d’un chauffage centralisés. Lits supplémentaires disponibles sur demande.",
      image: ChambreD,
      prix: "18500.00 DA/nuit",
      "option vue sur mer": "+ 2500.00 DA"
    },
    {
      id: 3,
      type: "Chambre Triple",
      description: "Chambres de 20 à 25 m², dotées d’une literie haut de gamme, d’un téléviseur plasma avec chaînes câblées, du Wi-Fi gratuit, d’un réfrigérateur, d’un coffre-fort, d’une salle de bain privative, ainsi que d’une climatisation et d’un chauffage centralisés. Lits supplémentaires disponibles sur demande.",
      image: ChambreT,
      prix: "27500.00 DA/nuit",
     "option vue sur mer": "+ 2500.00 DA"
    }
  ];

  // Filtrer uniquement les types de chambre à conserver
  const chambresFiltrees = chambres.filter(chambre =>
    ["Chambre Single", "Chambre Double", "Chambre Triple"].includes(chambre.type)
  );

  const handleReserve = (type) => {
    navigate('/Reservation', { state: { type } });
  };

  return (
    <div className="chambres-list">
  {chambresFiltrees.map((chambre) => (
    <div key={chambre.id} className="chambre-card">
      <div
        className="chambre-image"
        style={{ backgroundImage: `url(${chambre.image})` }}
      >
        <span className="prix-tag">{chambre.prix}</span>
      </div>
      <div className="chambre-content">
        <h3>{chambre.type}</h3>
        <p>{chambre.description}</p>
        <p className="option-vue"> Vu sur mer : {chambre["option vue sur mer"]}</p>
        <button className="reserver-btn" onClick={() => handleReserve(chambre.type)}>Réserver</button>
      </div>
    </div>
  ))}
</div>

  );
};

export default AobergePage;
